import { http } from "@/utils/request";

/**
 * 获取公司公告列表
 */
export const useGetAnnouncementListApi = async (params) => {
  console.log("公司公告接口-请求参数", params);
  const res = await http.post("/companyOfficialWebsite/siteNoticeListForOut", params);
  console.log("公司公告接口-返回数据", res);
  return res;
};
